import type { ReactNode } from 'react';

/**
 * StatCard
 * --------------------------------
 * Dashboard 顶部资产 / KPI 数据卡片。统一字号、间距、阴影。
 */
export interface StatCardProps {
  label: ReactNode;
  value: ReactNode;
  delta?: ReactNode;
  prefix?: ReactNode;
}

export function StatCard({ label, value, delta, prefix }: StatCardProps) {
  return (
    <div className="up-stat-card">
      <div className="up-stat-card__label">{label}</div>
      <div className="up-stat-card__value">
        {prefix}
        {value}
      </div>
      {delta ? <div className="up-stat-card__delta">{delta}</div> : null}
    </div>
  );
}
